import * as React from 'react';
import { Alert, AlertColor, Snackbar, SnackbarProps } from '@mui/material';

interface ConditionedSnackbarProps extends SnackbarProps {
    severity: AlertColor;
    handleClose: () => void;
}

const ConditionedSnackbar = (props: ConditionedSnackbarProps) => {
    const { open, handleClose, severity, message } = props;

    return (
        <Snackbar
            open={open}
            autoHideDuration={2000}
            onClose={handleClose}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center'
            }}>
            <Alert
                onClose={handleClose}
                severity={severity}
                variant="filled"
                sx={{ width: '100%' }}>
                {message}
            </Alert>
        </Snackbar>
    );
};

export default ConditionedSnackbar;
